import { render, staticRenderFns } from "./ModalSelectCliente.vue?vue&type=template&id=716c5f88&"
import script from "./ModalSelectCliente.vue?vue&type=script&lang=js&"
export * from "./ModalSelectCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports